import { Component, OnInit,OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertController } from '@ionic/angular';

import { FormControl, FormGroup } from '@angular/forms';



import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { Color,Label } from 'ng2-charts';
import { DataServicesService } from 'src/app/services/data-services.service';


@Component({
  selector: 'app-origin-park-chart',
  templateUrl: './origin-park-chart.component.html',
  styleUrls: ['./origin-park-chart.component.scss']
})
export class OriginParkChartComponent implements OnInit,OnDestroy {


  public barChartOptions: ChartOptions = {
    responsive: true,
    // We use these empty structures as placeholders for dynamic theming.
    scales: { xAxes: [{}], yAxes: [{}] },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    }
  };

  public barChartLabels: Label[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [pluginDataLabels];

  color = ['#4d9301','#ff7c43','#9CFF33','#82E617','#860999','#CA17E6','#6633cc','#aaaa11','#22aa99','#994499','#3366cc','#ed681d', '#F8CA0F', '#a32727' , '#2f4b7c', '#665191', '#a05195', '#d45087', '#f95d6a', '#ff7c43', '#ffa600','#743411','#0c5922',
            '#bea413','#668d1c','#2a778d','#a9c413','#9c5935','#f4359e','#b91383','#16d620','#b77322','#3b3eac','#5574a6','#329262','#651067',
            ,'#316395','#b82e2e','#66aa00','#dd4477','#0099c6','#990099'];

  public barChartColors: Color[] = [
    {
      borderColor: ['#ed681d', '#F8CA0F', '#a32727' , '#2f4b7c', '#665191', '#a05195', '#d45087', '#f95d6a', '#ff7c43', '#ffa600'],
      backgroundColor: ['#ed681d', '#F8CA0F', '#a32727' , '#2f4b7c', '#665191', '#a05195', '#d45087', '#f95d6a', '#ff7c43', '#ffa600'],
      borderWidth: 3
    }
  ];

  public barChartData: ChartDataSets[] = [
    { data: [], label: '' },
    // { data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B' }
  ];

  // availableRoutes =[];
  type = 'amount';
  tripOrigin;
  displayItem = [];

  routes; // = new FormControl();
  availableOrigins: string[] = [];

  reportStartTime = 0;//Date.now() - (24*60*60*1000);
  reportEndTime = Date.now() + 2*(24 * 60 * 60 * 1000);

  private bookingSubscription$: Subscription;

  constructor(private dataService: DataServicesService) { }

  ngOnInit(): void { //tripOrigin

    this.bookingSubscription$ = this.dataService.originsArray.subscribe(origin=>{
      if(origin.length){
        this.displayItem[0] = origin[0].trip_origin.substring(0,12);
        if(origin.length>1){
          this.displayItem[1] = origin[1].trip_origin.substring(0,12);
        }
      }
    });

    this.dataService.tripOrigin.subscribe(tripOrigin => {
      if (tripOrigin){
        // console.log(tripOrigin)
        this.tripOrigin  = tripOrigin;
        this.getRevenueGraph();
        // console.log(tripRoutes)
      }

    });
  }

  public ngOnDestroy(): void {
    if( this.bookingSubscription$){
      this.bookingSubscription$.unsubscribe();
    }
  }

  getRevenueGraph(){
    const originObject = {}
    this.availableOrigins = [];
    const availableRoutes={};
    this.type = 'amount';
    this.barChartLabels  = []
    this.barChartData[0].data = []
    this.tripOrigin.forEach(record =>{
      if(record){
        // console.log(record)
      let trip_origin = '';
      let trip_count = 0;
      let trip_amount = 0;
      if(record.trip_origin){
        trip_origin = record.trip_origin.substring(0,12);
      }
      if(record.trip_count){
        trip_count = record.trip_count
      }
      if(record.trip_amount){
        trip_amount = record.trip_amount
      }
      if(originObject[record.trip_date.value]){

        originObject[record.trip_date.value].push({
          trip_origin,
          trip_count ,
          trip_amount ,
        })
      } else {
        originObject[record.trip_date.value]=[];
        originObject[record.trip_date.value].push({
          trip_origin,
          trip_count ,
          trip_amount  ,
        })
      }
      availableRoutes[trip_origin]=1;
    }
    });


    this.availableOrigins = Object.keys(availableRoutes);

    const routeObjectKeys = Object.keys(originObject)
    const routeObjectElements = Object.values(originObject)
    let  day ;
    this.displayItem.forEach((item,ind) => {
      this.barChartData[ind]=  { data: [], label: '' },
      routeObjectKeys.forEach((dailyItem,index) =>{
        if(ind===0){
          this.barChartLabels.push(dailyItem);
        }
        // this.barChartLabels.push(dailyItem);
        day = routeObjectElements[index];
        const dayTrip = day.find(el=>el.trip_origin===item)
        if(dayTrip){
          this.barChartData[ind].data.push(dayTrip['trip_amount']);
        } else {
          this.barChartData[ind].data.push(0);
        }

      })
      this.barChartData[ind].label = item
      this.barChartData[ind].backgroundColor = this.color[ind] || '#000000'
    });

  }

  getCountGraph(){
    const originObject = {}
    this.availableOrigins = [];
    const availableRoutes={};
    this.type = 'count';
    this.barChartLabels  = []
    this.barChartData[0].data = []
    this.tripOrigin.forEach(record =>{
      if(record){
      let trip_origin = '';
      let trip_count = 0;
      let trip_amount = 0;
      if(record.trip_origin){
        trip_origin = record.trip_origin.substring(0,12);
      }
      if(record.trip_count){
        trip_count = record.trip_count
      }
      if(record.trip_amount){
        trip_amount = record.trip_amount
      }
      if(originObject[record.trip_date.value]){

        originObject[record.trip_date.value].push({
          trip_origin,
          trip_count ,
          trip_amount ,
        })
      } else {
        originObject[record.trip_date.value]=[];
        originObject[record.trip_date.value].push({
          trip_origin,
          trip_count ,
          trip_amount  ,
        })
      }
      availableRoutes[trip_origin]=1;
    }
    });


    this.availableOrigins = Object.keys(availableRoutes);

    const routeObjectKeys = Object.keys(originObject)
    const routeObjectElements = Object.values(originObject)
    let  day ;
    this.displayItem.forEach((item,ind) => {
      this.barChartData[ind]=  { data: [], label: '' },
      routeObjectKeys.forEach((dailyItem,index) =>{
        if(ind===0){
          this.barChartLabels.push(dailyItem);
        }
        // this.barChartLabels.push(dailyItem);
        day = routeObjectElements[index];
        const dayTrip = day.find(el=>el.trip_origin===item)
        if(dayTrip){
          this.barChartData[ind].data.push(dayTrip['trip_count']);
        } else {
          this.barChartData[ind].data.push(0);
        }

      })
      this.barChartData[ind].label = item
      this.barChartData[ind].backgroundColor = this.color[ind] || '#000000'
    });
  }


  routeChange($event){
    // console.log('Display before', this.displayItem)
    this.displayItem.forEach((dis,index)=>{
      this.barChartData[index]=  { data: [], label: '' }
    });

    this.displayItem = $event.value;
    this.getRevenueGraph();
    // console.log('Display after', this.displayItem)
  }

  startDateChange($event){
    if ($event) {
      this.reportStartTime = new Date($event.value).valueOf();
    }

  }

  endDateChange($event){
    if ($event){
      // const lastTime = this.reportEndTime;
      this.reportEndTime = new Date($event.value).valueOf() + 2*(24 * 60 * 60 * 1000);
      this.dataService.getTripOrigin(this.reportStartTime,this.reportEndTime);

    }

  }

  originDownload(){
    const headerList = ['Booking Date','Origin Park','Booking Count','Revenue']

    const objArray = [];
    this.tripOrigin.forEach((req,index) => {
      let oneDay = {
        'Booking Date': req.trip_date.value,
        'Origin Park': req.trip_origin,
        'Revenue': Number(req.trip_amount),
        'Booking Count':  Number(req.trip_count)
      }
      objArray.push(oneDay)
    })

    if(objArray.length){
      const data = this.ConvertToCSV(objArray,headerList);
      const fileName =  'Origin Park';//+new Date().toLocaleTimeString();
      this.downloadFile(data,fileName)
    }


   }

    ConvertToCSV(objArray, headerList) {
      let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      let str = '';
      let row = 'S.No,';
      for (let index in headerList) {
       row += headerList[index] + ',';
      }
      row = row.slice(0, -1);
      str += row + '\r\n';
      for (let i = 0; i < array.length; i++) {
       let line = (i+1)+'';
       for (let index in headerList) {
        let head = headerList[index];
        line += ',' + array[i][head];
       }
       str += line + '\r\n';
      }
      return str;
     }

    downloadFile(csvData, filename) {
      let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
      let dwldLink = document.createElement("a");
      let url = URL.createObjectURL(blob);
      let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
      if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
          dwldLink.setAttribute("target", "_blank");
      }
      dwldLink.setAttribute("href", url);
      dwldLink.setAttribute("download", filename + ".csv");
      dwldLink.style.visibility = "hidden";
      document.body.appendChild(dwldLink);
      dwldLink.click();
      document.body.removeChild(dwldLink);
    }



}
